/**
 * Factory file for project history related data.
 *
 * @exports userInfo
 * @category Factories
 */
export default {
  /**
   * Get userInfo
   *
   * @param {object} initialData
   * @returns {object}
   */
  getBrokerUserInfo(initialData = {}) {
    const broker = {
      name: 'Threeflow',
      logoUrl: 'https://watchtower-public.s3.amazonaws.com/organizations/logos/hays_companies_of_illinois_demo/original/fake_3x.png?1579814591',
      colors: {
        primaryColor: '#4583cb',
        secondaryColor: '#1bc788',
        primaryColorDarker: '#004282',
        primaryColorLight1: '#d6ffff',
        primaryColorLight2: '#c6f9ff',
      },
    };
    const userInfo = {
      id: 360,
      email: 'robbirrgang@watchtowerbenefits.com',
      firstName: 'Robb',
      lastName: 'Irrgang',
      roles: [{
        id: 1,
        name: 'admin',
      }],
      broker,
      carrier: {},
      ...initialData,
    };

    return userInfo;
  },
  getCarrierUserInfo: () => ({
    id: 144,
    email: 'voya@watchtowerbenefits.com',
    firstName: 'Mister',
    lastName: 'Professor',
    created: '2017-09-22T02:26:22.516664',
    role: '',
  }),
};
